import type { FeatureGroup } from '../../../types';
import { ADMINISTRATIVE_FEATURE_GROUP } from '../group';

export const NOTIFICATIONS_FEATURE_GROUP: FeatureGroup = {
  guid: '9df0460c-b4a3-4dd2-a925-652924c7af16',
  name: 'notifications',
  description: 'Personal notification preferences — which product alerts a user receives',
  product: 'account',
  parentGuid: ADMINISTRATIVE_FEATURE_GROUP.guid,
};
